//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {loadYmap} from 'vue-yandex-maps'

const settings = {
  apiKey: process.env.yandexMapApiKey,
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1'
}

export default {
  data() {
    return {
      imagesList: [],

      activeStore: null,

      index: null,
      yandexMap: null
    }
  },

  props: {
    store: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isShowAppointmentBtn: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {

    this.$modal.show('dialog-address-map')

    if (!this.store.stores) {
      await this.setImagesList()
    }
    await this.initMap()
  },

  computed: {
    imagesIds() {
      let imagesList = [];

      const mainImageId = this.storeData?.image_id || this.storeData?.imageId || this.storeData?.main_image;
      if (mainImageId) {
        imagesList.push(mainImageId)
      }

      JSON.parse(this.storeData?.images || '[]').forEach(t => {
        imagesList.push(t.imageId)
      })

      const additionalImageIds = [...(this.storeData?.images_ids || this.storeData?.imagesIds || [])];

      if (additionalImageIds.length) {
        imagesList = [...additionalImageIds];
      }

      return imagesList;
    },

    storeData() {
      let store = this.store;

      if (!this.store.stores) {
        return store
      }

      store =
        (this.store.stores || []).find(t => t.id === this.activeStore) || {}

      return store
    },

    cityName: function () {
      return this.storeData?.city_name || this.storeData?.cityName || this?.storeData?.city?.city_name || ""
    },
    workPhone: function () {
      return this.storeData?.work_phone || this.storeData?.workPhone || ""
    },
    workingHours: function () {
      return (this.storeData?.working_hours || this.storeData?.workingHours || "").split(', ');
    },
  },

  methods: {
    onAppointment() {
      this.$emit('onAppointment', this.storeData);
    },

    setImagesList() {
      const imagesList = [];

      [...this.imagesIds]
        .map((imageId) => {
          imagesList.push(
            this.$img(imageId.toString(), {width: 1900, quality: 90})
          )
        })

      this.imagesList = imagesList
    },

    async initMap() {
      await this.yandexMapDestroy()
      await this.yandexMapInit()
    },
    async yandexMapInit() {
      await loadYmap({...settings, debug: true})

      this.yandexMap = new ymaps.Map(
        'yandex-map',
        {
          center: [this.store?.lat, this.store?.lon],
          zoom: 12,
          behaviors: ['drag', 'dblClickZoom', 'multiTouch']
        },
        {
          maxZoom: 17
        }
      )

      this.yandexMapSetMarkers()
    },
    yandexMapSetMarkers() {
      if (!this.yandexMap) {
        return null
      }

      const yandexMap = this.yandexMap
      const self = this

      const stores = this.store.stores || [this.store] || []
      this.activeStore = this.activeStore || stores?.[0]?.id

      this.setImagesList()

      stores.map((store) => {
        // Разработка визуальной части маркера
        const contentLayout = ymaps.templateLayoutFactory.createClass(
          `<div class="store-map-pointer ${
            this.activeStore === store.id ? 'store-map-pointer--active' : ''
          }"><span>${store.address}</span></div>`
        )

        // Настройка паркера
        const myPlacemarkWithContent = new ymaps.Placemark(
          [store.lat, store.lon],
          {},
          {
            iconLayout: 'default#imageWithContent',
            iconImageHref: '',
            content: '',
            contentLayout: '',
            imageSize: [60, 60],
            imageOffset: [-30, -30],
            contentOffset: [30, 20],
            iconContentLayout: contentLayout
          }
        )

        myPlacemarkWithContent.events.add('click', async function () {
          await self.onTapMarker(store.id)
        })

        // Добавление маркера на карту
        yandexMap.geoObjects.add(myPlacemarkWithContent)
      })

      // Автоцентрирование карта с отступами
      yandexMap.setBounds(yandexMap.geoObjects.getBounds(), {
        checkZoomRange: false
      })
    },
    async yandexMapDestroy() {
      if (!this.yandexMap) {
        return null
      }
      await this.yandexMap?.geoObjects?.removeAll()
    },

    async onTapMarker(storeId) {
      if (this.activeStore === +storeId) {
        return null
      }

      this.activeStore = +storeId
      await this.yandexMapDestroy()
      this.yandexMapSetMarkers()
    },

    close() {
      this.$emit('onClose')
    }
  }
}
